import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
    namespaced: true,
    state() {
        return {
            delivery: {},
            deliveryStats: null,
            deliveryStatsLoading: false,
            statsRefreshCooldownUntil: 0,
        }
    },
    mutations,
    actions,
    getters
}